import { useApi } from "../../../contexts/app/provider";
import { useGetMyDataHubPullFilesQuery } from "../../../services/api/__generated__/backend_gateway-types";
import { DataPullsPanelComponent } from "./component";

export const DataPullsPanelContainer = () => {
  const { apiService } = useApi();

  const { data, loading, error } = useGetMyDataHubPullFilesQuery({
    client: apiService.getClient(),
  });

  // The panel is informational — if the report errors or the org has no pull
  // config, Run History should look exactly like it did before. Nothing
  // renders until the report confirms there are sources, so orgs without a
  // pull config never see a 40%-tall loading panel flash in and vanish.
  if (loading || error) {
    return null;
  }
  const report = data?.getMyDataHubPullFiles || null;
  if (!report || report.sources.length === 0) {
    return null;
  }

  return <DataPullsPanelComponent loading={false} report={report} />;
};
